import { datadogRum } from '@datadog/browser-rum';
import { useContext, useEffect, useRef } from 'react';
import { validSoftPullSortOptions } from '~/constants/srp/SortOption';
import SortOption from '~/constants/srp/SortOption';
import AppliedFiltersContext from '~/context/srp/AppliedFiltersContext';
import { useCreditStatus } from '~/context/srp/FinanceContext/FinanceContext';

/**
 * Ensure that user has a valid soft pull before setting sort by.
 *
 * If the Credit Status API responds with an invalid soft pull, set the sort by
 * to Lowest Price. The Credit Status API is awaited in useIsRequiredInventoryDataAvailable()
 * if the current sort by option is one of the options that require a valid soft pull.
 */
export default function useEnsureValidSortBy() {
  const { setSortBy, sortBy } = useContext(AppliedFiltersContext);
  const sortByRef = useRef<SortOption>(sortBy);
  const {
    data: { creditStatus: { hasValidSoftPull } = {} },
    isLoaded: isCreditStatusLoaded
  } = useCreditStatus();

  useEffect(() => {
    if (
      isCreditStatusLoaded &&
      !hasValidSoftPull &&
      validSoftPullSortOptions.includes(sortByRef.current)
    ) {
      datadogRum.addAction('Search sort updated', {
        reason: 'invalid soft pull',
        sortBy: sortByRef.current
      });
      setSortBy(SortOption.LowestPrice);
    }
  }, [hasValidSoftPull, isCreditStatusLoaded, setSortBy, sortBy]);
}
